// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__Wkz2d","loader":"Loader_loader__USO0W","spinanimation":"Loader_spinanimation__EsT5H"};